/**
 * Validate expense form
 */
export const validateExpenseForm = (
    description,
    amount,
    selectedExpenseAccount
) => {
    return (
        description &&
        amount &&
        parseFloat(amount) > 0 &&
        selectedExpenseAccount
    );
};

/**
 * Validate purchase form
 */
export const validatePurchaseForm = (
    isPaymentMode,
    selectedSupplier,
    paymentAmount,
    selectedItems,
    stockEntryTotal,
    purchasePaidAmount
) => {
    if (isPaymentMode) {
        return (
            selectedSupplier && paymentAmount && parseFloat(paymentAmount) > 0
        );
    } else {
        return (
            selectedItems.length > 0 &&
            stockEntryTotal > 0 &&
            selectedSupplier &&
            purchasePaidAmount &&
            parseFloat(purchasePaidAmount) > 0 &&
            parseFloat(purchasePaidAmount) <= stockEntryTotal
        );
    }
};

/**
 * Validate employee advance form
 */
export const validateEmployeeAdvanceForm = (
    advanceReason,
    advanceAmount,
    selectedEmployee
) => {
    return (
        advanceReason &&
        advanceAmount &&
        parseFloat(advanceAmount) > 0 &&
        selectedEmployee
    );
};

/**
 * Validate item creation form
 */
export const validateItemCreationForm = (
    item_name,
    item_group,
    purchase_rate
) => {
    return item_name && item_group && purchase_rate;
};

/**
 * Get form validation status based on current tab
 */
export const isFormValid = (currentTab, formData) => {
    switch (currentTab) {
        case 0: // Expense
            return validateExpenseForm(
                formData.description,
                formData.amount,
                formData.selectedExpenseAccount
            );
        case 1: // Purchase
            return validatePurchaseForm(
                formData.isPaymentMode,
                formData.selectedSupplier,
                formData.paymentAmount,
                formData.selectedItems,
                formData.stockEntryTotal,
                formData.purchasePaidAmount
            );
        case 2: // Employee Advance
            return validateEmployeeAdvanceForm(
                formData.advanceReason,
                formData.advanceAmount,
                formData.selectedEmployee
            );
        default:
            return false;
    }
};
